var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-name-with-thumbnail"},[(_vm.product.thumb.length > 0)?_c('img',{attrs:{"src":_vm.product.thumb[0].currentMedia.url}}):_c('img',{staticClass:"no-thumbnail",attrs:{"src":require('@/assets/images/image-placeholder-grayscale.webp')}}),_c('span',{staticClass:"product-name"},[_vm._v(_vm._s(_vm.product.product_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }